import { useMemo } from 'react'
import './DateInput.scss'
import { isEmpty } from '../../Utils/Validations'
import DatePicker from 'react-date-picker'
import { type Value } from 'react-date-picker/dist/cjs/shared/types'

import 'react-date-picker/dist/DatePicker.css'
import 'react-calendar/dist/Calendar.css'

interface DateInputProps {
  value?: number
  onChange?: (newValue: number | undefined) => void
  label?: string
  helperText?: string
  isValid?: boolean
  isReadOnly?: boolean
  min?: number
  max?: number
}

export function DateInput({
  value,
  onChange,
  label,
  helperText,
  isValid,
  isReadOnly,
  min,
  max,
}: DateInputProps) {
  const handleInputChange = (value: Value) => {
    console.log('handleInputChange: ', value)
    if (onChange) {
      if (value == null) onChange(undefined)
      else onChange((value as Date).getTime())
    }
  }

  const dateValue = useMemo(
    () => (value != null ? new Date(value) : undefined),
    [value]
  )

  return (
    <div
      className={`date-input ${isValid === false ? 'invalid' : ''} ${
        isReadOnly ?? false ? 'is-read-only' : ''
      }`}
    >
      {!isEmpty(label) ? <div className="input-label">{label}</div> : null}{' '}
      <div className="input-element-wrapper">
        <DatePicker
          className="input-element-date-picker"
          value={dateValue}
          onChange={handleInputChange}
          minDate={min == null ? undefined : new Date(min)}
          maxDate={max == null ? undefined : new Date(max)}
          disabled={isReadOnly}
          format="dd/MM/y"
        />
      </div>
      {!isEmpty(helperText) ? (
        <div className="input-helper-text">{helperText}</div>
      ) : null}
    </div>
  )
}
